export default "__VITE_ASSET__BXiNcRY7__"